import { SxProps, Theme } from "@mui/material/styles";

export const menuPaperStyles: SxProps<Theme> = (theme) => ({
  "& .MuiPaper-root": {
    backgroundColor: theme.palette.footer.menuDropdown?.bgColor,
    minWidth: "145px",
    maxWidth: "300px",
    width: "100%",
    mt: -13,
    borderRadius: "18px",
    py: "10px",
    "@media (orientation: landscape) and (max-width: 900px) and (pointer: coarse)": {
      maxWidth: "240px",
      mt: -9,
      borderRadius: "14px",
      paddingTop: "6px",
      paddingBottom: "6px",
    },
  },
});

export const defaultMenuItem: SxProps<Theme> = (theme) => ({
  color: "#1F2937",
  "&:hover": {
    background: theme.palette.footer.menuDropdown?.bgColorHover,
  },
});

export const typographyStyle: SxProps<Theme> = (theme) => ({
  fontSize: "16px",
  fontFamily: "Red Hat Display",
  fontWeight: 500,
  color: theme.palette.footer.menuDropdown?.textColor,
});

export const selectedItemContainer: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "10px",
  "&:hover": {
    background: theme.palette.footer.menuDropdown?.bgColorHover,
  },
});

export const selectedItemBox: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: "4px",
};

export const selectedItemTitle: SxProps<Theme> = {
  fontSize: "16px",
  fontWeight: 600,
  color: "#06B6D4",
};

export const selectedItemDescription: SxProps<Theme> = (theme) => ({
  fontSize: "12px",
  color: theme.palette.footer.menuDropdown?.descriptionColor,
  flexWrap: "wrap",
});

export const goButton: SxProps<Theme> = {
  background: "#06B6D4",
  borderRadius: "8px",
  fontSize: "10px",
  color: "#FFFFFF",
  "&:hover": {
    background: "#06B6D4CC",
  },
};
